import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'
import Tag, {ITag} from '@/models/Tag'

export interface ITagging extends IModelBase {
  tag_id: number
  tag?: ITag
}

export default class Tagging extends ModelBase {
  tag_id: number
  tag: Tag

  constructor(defaults?: ITagging) {
    super(defaults)
    if (defaults) {
      this.tag_id = defaults.tag_id
      this.tag = new Tag(defaults.tag)
    }
  }

  toParams(): KeyPair {
    return {}
  }
}
